/**
 * Environment Configuration Utility
 * Centralized configuration management for different environments
 */

// Get environment from process.env or default to 'development'
const getCurrentEnvironment = () => {
  return process.env.REACT_APP_ENV || 'development';
};

// Environment configuration object
const config = {
  // Environment info
  env: getCurrentEnvironment(),
  isDevelopment: getCurrentEnvironment() === 'local' || getCurrentEnvironment() === 'development',
  isProduction: getCurrentEnvironment() === 'production',
  
  // API Configuration
  api: {
    baseURL: process.env.REACT_APP_API_URL || 'https://apidev.perfectlayout.in',
    baseApiURL: process.env.REACT_APP_API_BASE_URL || 'https://apidev.perfectlayout.in/api/v1',
    authURL: process.env.REACT_APP_AUTH_URL || 'https://apidev.perfectlayout.in/api/v1/auth',
    uploadURL: process.env.REACT_APP_UPLOAD_URL || 'https://apidev.perfectlayout.in/api/v1/upload',
    mapURL: process.env.REACT_APP_MAP_URL || 'https://apidev.perfectlayout.in/api/v1/map_project_locations',
  },
  
  // App Configuration
  app: {
    name: process.env.REACT_APP_APP_NAME || 'PerfectLayout',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    debug: process.env.REACT_APP_DEBUG === 'true',
    logLevel: process.env.REACT_APP_LOG_LEVEL || 'info',
  },
  
  // Feature Flags
  features: {
    devTools: process.env.REACT_APP_ENABLE_DEV_TOOLS === 'true',
    mockData: process.env.REACT_APP_ENABLE_MOCK_DATA === 'true',
    analytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  },
  
  // Logging configuration
  logging: {
    enabled: process.env.REACT_APP_DEBUG === 'true',
    level: process.env.REACT_APP_LOG_LEVEL || 'info',
  }
};

// Helper functions
export const getApiURL = () => config.api.baseURL;
export const getApiBaseURL = () => config.api.baseApiURL;
export const getAuthURL = () => config.api.authURL;
export const getUploadURL = () => config.api.uploadURL;
export const getMapURL = () => config.api.mapURL;

export const isDevelopment = () => config.isDevelopment;
export const isProduction = () => config.isProduction;
export const getEnvironment = () => config.env;

export const isFeatureEnabled = (feature) => {
  return config.features[feature] || false;
};

export const log = (message, level = 'info') => {
  if (config.logging.enabled) {
    const levels = ['error', 'warn', 'info', 'debug'];
    const currentLevelIndex = levels.indexOf(config.logging.level);
    const messageLevelIndex = levels.indexOf(level);
    
    if (messageLevelIndex <= currentLevelIndex) {
      console[level](`[${config.env.toUpperCase()}] ${message}`);
    }
  }
};

// Export the main config object
export default config;
